import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import './agenthero.scss'
import { images } from '../../../utils/customFn'
const AgentHero = () => {
    return (
        <div className='agenthero'>
            <Row>
                <Col md={8} sm={12}>
                    <div className='leftsidecontent'>
                        <div className='common-heading'>
                            <h2>Manage your accounts</h2>
                        </div>
                        <div className='text'>
                            <p>We make it easy for you to get important information for your clients. Whether it’s getting an insurance quote, reporting a claim, or seeking industry thought leadership, you can trust us to get the answers you need quickly.</p>
                            <p>Sign in here to access and manage your customer accounts.</p>
                        </div>
                        <div className='loginbtn'>
                            <Link to='' className='link primaryButtonLink'>Log in</Link>
                        </div>
                    </div>
                </Col>
                <Col md={4} sm={12}>
                    <div className='hero-img'>
                        <img src={images['microsoftTeams-image.avif']} />
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default AgentHero;
